export class HomeModel {
  public periodIdStart: number | null = null;
  public periodIdEnd: number | null = null;
  public order: string = '';
  public campusId?: number;
  public entityCode?: string;
  public type?: number;
}
